// Free geocoding via OpenStreetMap Nominatim — no API key needed
// Rate limit: 1 request/second max, which is fine for one submission at a time

const BASE = 'https://nominatim.openstreetmap.org/search'
const HEADERS = { 'Accept-Language': 'en', 'User-Agent': 'WindSportsDirectory/1.0' }

/**
 * Geocode a full address string to { lat, lng } or null if not found.
 * Tries full address first, falls back to city + country.
 */
export async function geocodeListing({ address, city, country }) {
  // Build query — prefer full address if available
  const query = address
    ? `${address}, ${city || ''}, ${country || ''}`
    : `${city || ''}, ${country || ''}`

  try {
    const url = `${BASE}?q=${encodeURIComponent(query)}&format=json&limit=1`
    const res  = await fetch(url, { headers: HEADERS })
    const data = await res.json()

    if (data && data.length > 0) {
      return {
        lat: parseFloat(data[0].lat),
        lng: parseFloat(data[0].lon),
      }
    }

    // If full address failed, try just city + country as fallback
    if (address && (city || country)) {
      await sleep(1100)  // respect 1 req/sec rate limit
      const fallbackUrl = `${BASE}?q=${encodeURIComponent(`${city || ''}, ${country || ''}`)}&format=json&limit=1`
      const fallbackRes  = await fetch(fallbackUrl, { headers: HEADERS })
      const fallbackData = await fallbackRes.json()
      if (fallbackData && fallbackData.length > 0) {
        return {
          lat: parseFloat(fallbackData[0].lat),
          lng: parseFloat(fallbackData[0].lon),
        }
      }
    }

    return null
  } catch (err) {
    console.warn('Geocoding failed:', err)
    return null
  }
}

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}
